import React, { Suspense, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Box, Button, Card, CardContent, CardHeader, Link, ListItemText, MenuItem } from '@mui/material';
import CheckboxList from 'components/common/CheckboxList';
import { isFProject } from 'config/project';
import useContextMenu from 'hooks/useContextMenu';
import { TransportationModel, TransportationStatus } from 'models/TransportationModel';
import { CompanyType } from 'models/CompanyModel';
import useCompanyModals from 'modules/companies/hooks/useCompanyModals';
import auth from 'recoil/atoms/auth';
import companyList from 'recoil/atoms/companyList';
import Api from 'utils/api';


const NonAssignedInner = () => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation();
    const companies = useRecoilValue(companyList(CompanyType.TransportAgent));
    const [transportations, setTransportations] = useState<TransportationModel[]>([]);
    const [checked, setChecked] = useState<boolean[]>([]);
    const {openAddCompanyModal} = useCompanyModals(CompanyType.TransportAgent);

    const load = () => {
        Api.transportation
            .all(TransportationStatus.NonAssigned)
            .then(res => {
                res.data.sort((a: TransportationModel, b: TransportationModel) => (a.to.id - b.to.id) || (a.from.id - b.from.id) || (a.car.company.id - b.car.company.id));
                setTransportations(res.data);
                setChecked(res.data.map(() => false))
            });
    };

    useEffect(load, []);

    const {openMenu} = useContextMenu(
        ({close}) => companies.map(company => (
            <MenuItem
                key={company.id}
                onClick={() => {
                    const selected = transportations
                        .filter((_, i) => checked[i])
                        .map(tr => tr.id);

                    if (selected.length)
                        Api.transportation
                            .setAgent(company.id, selected)
                            .then(load);

                    close();
                }}
            >
                <ListItemText>{company.name}</ListItemText>
            </MenuItem>
        ))
    );

    const assignButton = () => (
        <>
            <Button
                size="small"
                onClick={openAddCompanyModal}
            >
                {t('add')}
            </Button>
            {' '}
            <Button
                size="small"
                onClick={openMenu}
            >
                {t('assign_agent')}
            </Button>
        </>
    );

    return (
        <Card>
            <CardHeader
                action={my.permissions.has('cars view') ? assignButton() : undefined}
            />
            <CardContent>
                <Box sx={{overflow: 'auto', maxHeight: 'calc(100vh - 230px)'}}>
                    <CheckboxList
                        items={transportations}
                        formatter={order => <Box display="flex" justifyContent="space-between">
                            <Box>{order.car.model} {!!order.car.damaged && !isFProject && <Box component="strong" color="error.light">DMG</Box>} <Link href={`/car/${order.car.id}`}>{order.car.chassisNumber}</Link></Box>
                            <Box sx={{flexGrow: 1, margin: '0 1.5rem', textAlign: 'right'}}>{order.car.company.name}</Box>
                            <Box>{order.from.port.name} {order.from.name} - {order.to.port.name} {order.to.name}</Box>
                        </Box>}
                        checked={checked}
                        setChecked={setChecked}
                    />
                </Box>
            </CardContent>
        </Card>
    )
};

const NonAssigned = () => {
    return (
        <Suspense fallback={null}>
            <NonAssignedInner/>
        </Suspense>
    )
};

export default NonAssigned;
